import { openBlock as c, createElementBlock as r, normalizeClass as H, renderSlot as d, createElementVNode as i, resolveComponent as S, Fragment as B, renderList as L, toDisplayString as k, createVNode as _, withCtx as a, createBlock as C, createCommentVNode as y, createTextVNode as g, resolveDirective as q, withDirectives as V, Teleport as O } from "vue";
const M = (l, e) => {
  const o = l.__vccOpts || l;
  for (const [s, t] of e)
    o[s] = t;
  return o;
}, z = {
  name: "CookieComplyButton",
  props: {
    className: { type: String, required: !1, default: "" }
  },
  emits: ["handleClick"],
  methods: {
    handleClick() {
      this.$emit("handleClick");
    }
  }
};
function Z(l, e, o, s, t, n) {
  return c(), r("button", {
    class: H(["cookie-comply__button", o.className]),
    onClick: e[0] || (e[0] = (...u) => n.handleClick && n.handleClick(...u))
  }, [
    d(l.$slots, "default")
  ], 2);
}
const E = /* @__PURE__ */ M(z, [["render", Z]]);
const Y = {
  name: "CookieComplySwitch",
  props: {
    value: { type: String, required: !0 },
    isRequired: { type: Boolean, default: !1 },
    isDefaultEnable: { type: Boolean, default: !1 },
    isChecked: { type: Boolean, default: !1 }
  },
  emits: ["update:checkbox"],
  data() {
    return {
      isEnable: !1
    };
  },
  mounted() {
    (this.isRequired || this.isDefaultEnable || this.isChecked) && (this.isEnable = !0, this.$emit("update:checkbox", { value: this.value, isEnable: !0 }));
  },
  methods: {
    onToggle(l) {
      this.isEnable = !this.isEnable, this.$emit("update:checkbox", { value: l, isEnable: this.isEnable });
    }
  }
}, J = ["title"], G = ["id", "value", "disabled", "checked"];
function U(l, e, o, s, t, n) {
  return c(), r("label", {
    class: "cookie-comply-switch",
    title: o.isRequired ? "is required" : o.value
  }, [
    i("input", {
      id: o.value,
      type: "checkbox",
      value: o.value,
      disabled: o.isRequired,
      checked: o.isRequired || o.isDefaultEnable || o.isChecked,
      onInput: e[0] || (e[0] = (u) => n.onToggle(u.target.value))
    }, null, 40, G),
    i("span", {
      class: H(["cookie-comply-slider cookie-comply-round", { "cookie-comply-required": o.isRequired }])
    }, null, 2)
  ], 8, J);
}
const W = /* @__PURE__ */ M(Y, [["render", U]]), Q = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yIDJMMjYgMjYiIHN0cm9rZT0iIzBEMEQwRCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI2IDJMMiAyNiIgc3Ryb2tlPSIjMEQwRDBEIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
const F = {
  name: "CookieComplyModal",
  components: {
    CookieComplyButton: E,
    CookieComplySwitch: W
  },
  props: {
    preferences: { type: Array, default: () => [] },
    showAcceptAllInModal: { type: Boolean, default: !1 }
  },
  emits: ["cookie-comply-save", "cookie-comply-close", "cookie-comply-accept-all"],
  data() {
    return {
      checkedValues: []
    };
  },
  methods: {
    handleCheckboxUpdate({ value: l, isEnable: e }) {
      e ? this.checkedValues.push(l) : this.checkedValues.splice(this.checkedValues.indexOf(l), 1);
    },
    onSaveConfiguration() {
      this.$emit("cookie-comply-save", this.checkedValues);
    },
    acceptAll() {
      this.$emit("cookie-comply-accept-all");
    },
    onCloseModal() {
      this.$emit("cookie-comply-close");
    },
    getIsChecked(l) {
      const e = localStorage.getItem("cookie-comply");
      return e ? e === "all" ? !0 : !!JSON.parse(e).includes(l) : !1;
    }
  }
}, K = { class: "cookie-comply__modal" }, X = { class: "cookie-comply__modal-middle" }, $ = { class: "cookie-comply__modal-inner" }, ee = { class: "cookie-comply__modal-header" }, oe = /* @__PURE__ */ i("h3", null, "Your privacy preferences", -1), le = { class: "cookie-comply__modal-content" }, te = ["innerHTML"], ne = { class: "cookie-comply__modal-footer" }, ie = /* @__PURE__ */ g(" Save Settings "), ce = /* @__PURE__ */ g(" Accept All ");
function se(l, e, o, s, t, n) {
  const u = S("cookie-comply-switch"), v = S("cookie-comply-button");
  return c(), r("div", K, [
    i("div", X, [
      i("div", $, [
        i("img", {
          alt: "Back arrow",
          src: Q,
          class: "cookie-comply__close-icon",
          onClick: e[0] || (e[0] = (...f) => n.onCloseModal && n.onCloseModal(...f))
        }),
        i("header", ee, [
          d(l.$slots, "modal-header", {}, () => [
            oe
          ])
        ]),
        i("main", le, [
          (c(!0), r(B, null, L(o.preferences, (f, p) => (c(), r("div", { key: p }, [
            d(l.$slots, "modal-body", {
              preference: f,
              index: p
            }, () => [
              i("h2", null, k(f.title), 1),
              i("p", {
                innerHTML: f.description
              }, null, 8, te),
              (c(!0), r(B, null, L(f.items, (m) => (c(), r("div", {
                key: m.value,
                class: "cookie-comply__modal-switches"
              }, [
                i("h3", null, k(m.label), 1),
                _(u, {
                  value: m.value,
                  "is-required": m.isRequired,
                  "is-default-enable": m.isEnable,
                  "is-checked": n.getIsChecked(m.value),
                  "onUpdate:checkbox": n.handleCheckboxUpdate
                }, null, 8, ["value", "is-required", "is-default-enable", "is-checked", "onUpdate:checkbox"])
              ]))), 128))
            ])
          ]))), 128))
        ]),
        i("footer", ne, [
          d(l.$slots, "modal-footer", {}, () => [
            _(v, { onHandleClick: n.onSaveConfiguration }, {
              default: a(() => [
                ie
              ]),
              _: 1
            }, 8, ["onHandleClick"]),
            o.showAcceptAllInModal ? (c(), C(v, {
              key: 0,
              "class-name": "cookie-comply__button-accept",
              onHandleClick: n.acceptAll
            }, {
              default: a(() => [
                ce
              ]),
              _: 1
            }, 8, ["onHandleClick"])) : y("", !0)
          ])
        ])
      ])
    ])
  ]);
}
const ae = /* @__PURE__ */ M(F, [["render", se]]);
function de(l) {
  if (Array.isArray(l)) {
    for (var e = 0, o = Array(l.length); e < l.length; e++)
      o[e] = l[e];
    return o;
  } else
    return Array.from(l);
}
var T = !1;
if (typeof window < "u") {
  var P = {
    get passive() {
      T = !0;
    }
  };
  window.addEventListener("testPassive", null, P), window.removeEventListener("testPassive", null, P);
}
var x = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), h = [], A = !1, N = -1, b = void 0, w = void 0, j = function(e) {
  return h.some(function(o) {
    return !!(o.options.allowTouchMove && o.options.allowTouchMove(e));
  });
}, I = function(e) {
  var o = e || window.event;
  return j(o.target) || o.touches.length > 1 ? !0 : (o.preventDefault && o.preventDefault(), !1);
}, re = function(e) {
  if (w === void 0) {
    var o = !!e && e.reserveScrollBarGap === !0, s = window.innerWidth - document.documentElement.clientWidth;
    o && s > 0 && (w = document.body.style.paddingRight, document.body.style.paddingRight = s + "px");
  }
  b === void 0 && (b = document.body.style.overflow, document.body.style.overflow = "hidden");
}, ue = function() {
  w !== void 0 && (document.body.style.paddingRight = w, w = void 0), b !== void 0 && (document.body.style.overflow = b, b = void 0);
}, me = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, fe = function(e, o) {
  var s = e.targetTouches[0].clientY - N;
  return j(e.target) ? !1 : o && o.scrollTop === 0 && s > 0 || me(o) && s < 0 ? I(e) : (e.stopPropagation(), !0);
}, R = function(e, o) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!h.some(function(t) {
    return t.targetElement === e;
  })) {
    var s = {
      targetElement: e,
      options: o || {}
    };
    h = [].concat(de(h), [s]), x ? (e.ontouchstart = function(t) {
      t.targetTouches.length === 1 && (N = t.targetTouches[0].clientY);
    }, e.ontouchmove = function(t) {
      t.targetTouches.length === 1 && fe(t, e);
    }, A || (document.addEventListener("touchmove", I, T ? { passive: !1 } : void 0), A = !0)) : re(o);
  }
}, D = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  h = h.filter(function(o) {
    return o.targetElement !== e;
  }), x ? (e.ontouchstart = null, e.ontouchmove = null, A && h.length === 0 && (document.removeEventListener("touchmove", I, T ? { passive: !1 } : void 0), A = !1)) : h.length || ue();
};
const pe = {
  mounted(l, e) {
    e.value && R(l);
  },
  updated(l, e) {
    e.value ? R(l) : D(l);
  },
  unmounted(l) {
    D(l);
  }
}, he = {
  name: "CookieComply",
  components: { CookieComplyModal: ae, CookieComplyButton: E },
  directives: {
    "scroll-lock": pe
  },
  props: {
    headerTitle: { type: String, default: "Cookie settings" },
    headerDescription: {
      type: String,
      default: "We use cookies and similar technologies to help personalize content and offer a better experience. You can opt to customize them by clicking the preferences button."
    },
    preferencesLabel: { type: String, default: "Preferences" },
    acceptAllLabel: { type: String, default: "Accept All" },
    rejectAllLabel: { type: String, default: "Reject All" },
    preferences: { type: Array, default: () => [] },
    target: { type: String, default: "body" },
    greyOutBody: { type: Boolean, default: !1 },
    showAcceptAllInModal: { type: Boolean, default: !1 },
    showEditButton: {
      type: Boolean,
      default: !1
    },
    editCookieIconPath: {
      type: String,
      default: "~@/../src/assets/cookie_edit.svg"
    }
  },
  emits: [
    "on-accept-all-cookies",
    "on-save-cookie-preferences",
    "on-reject-all-cookies"
  ],
  data() {
    return {
      showCookieComply: !0,
      isModalOpen: !1
    };
  },
  mounted() {
    localStorage.getItem("cookie-comply") && (this.showCookieComply = !1);
  },
  methods: {
    handleAcceptAll() {
      this.showCookieComply = !1, localStorage.setItem("cookie-comply", "all"), this.$emit("on-accept-all-cookies");
    },
    handleRejectAll() {
      this.showCookieComply = !1, localStorage.setItem("cookie-comply", "[]"), this.$emit("on-reject-all-cookies");
    },
    openPreferences() {
      this.isModalOpen = !0;
    },
    onSave(l) {
      this.isModalOpen = !1, this.showCookieComply = !1;
      const e = Object.values(l);
      localStorage.setItem("cookie-comply", JSON.stringify(e)), this.$emit("on-save-cookie-preferences", e);
    }
  }
}, ye = {
  key: 0,
  class: "cookie-comply-body-grey-out"
}, ke = { class: "cookie-comply__header" }, _e = { class: "cookie-comply__header-title" }, ve = ["innerHTML"], Ce = { class: "cookie-comply__actions" }, ge = {
  key: 2,
  class: "cookie-comply-edit"
}, be = ["src"];
function we(l, e, o, s, t, n) {
  const u = S("cookie-comply-button"), v = S("cookie-comply-modal"), f = q("scroll-lock");
  return c(), r(B, null, [
    o.greyOutBody && t.showCookieComply ? (c(), r("div", ye)) : y("", !0),
    t.showCookieComply ? V((c(), r("aside", {
      key: 1,
      class: H(["cookie-comply", { "cookie-comply--modal-open": t.isModalOpen }])
    }, [
      i("div", ke, [
        d(l.$slots, "header", {}, () => [
          i("h3", _e, k(o.headerTitle), 1),
          i("p", {
            class: "cookie-comply__header-description",
            innerHTML: o.headerDescription
          }, null, 8, ve)
        ])
      ]),
      i("div", Ce, [
        _(u, { onHandleClick: n.handleRejectAll }, {
          default: a(() => [
            g(k(o.rejectAllLabel), 1)
          ]),
          _: 1
        }, 8, ["onHandleClick"]),
        _(u, { onHandleClick: n.openPreferences }, {
          default: a(() => [
            g(k(o.preferencesLabel), 1)
          ]),
          _: 1
        }, 8, ["onHandleClick"]),
        _(u, {
          "class-name": "cookie-comply__button-accept",
          onHandleClick: n.handleAcceptAll
        }, {
          default: a(() => [
            g(k(o.acceptAllLabel), 1)
          ]),
          _: 1
        }, 8, ["onHandleClick"])
      ]),
      (c(), C(O, { to: o.target }, [
        t.isModalOpen ? (c(), C(v, {
          key: 0,
          preferences: o.preferences,
          "show-accept-all-in-modal": o.showAcceptAllInModal,
          onCookieComplySave: n.onSave,
          onCookieComplyAcceptAll: n.handleAcceptAll,
          onCookieComplyClose: e[0] || (e[0] = (p) => t.isModalOpen = !1)
        }, {
          "modal-header": a(() => [
            d(l.$slots, "modal-header")
          ]),
          "modal-body": a(({ preference: p, index: m }) => [
            d(l.$slots, "modal-body", {
              preference: p,
              index: m
            })
          ]),
          "modal-footer": a(() => [
            d(l.$slots, "modal-footer")
          ]),
          _: 3
        }, 8, ["preferences", "show-accept-all-in-modal", "onCookieComplySave", "onCookieComplyAcceptAll"])) : y("", !0)
      ], 8, ["to"]))
    ], 2)), [
      [f, t.showCookieComply]
    ]) : y("", !0),
    o.showEditButton && !t.showCookieComply ? (c(), r("aside", ge, [
      _(u, {
        onHandleClick: n.openPreferences,
        className: "cookie-comply__edit-button"
      }, {
        default: a(() => [
          i("img", {
            src: o.editCookieIconPath,
            alt: "edit cookies"
          }, null, 8, be)
        ]),
        _: 1
      }, 8, ["onHandleClick"]),
      (c(), C(O, { to: o.target }, [
        t.isModalOpen ? (c(), C(v, {
          key: 0,
          preferences: o.preferences,
          "show-accept-all-in-modal": o.showAcceptAllInModal,
          onCookieComplySave: n.onSave,
          onCookieComplyAcceptAll: n.handleAcceptAll,
          onCookieComplyClose: e[1] || (e[1] = (p) => t.isModalOpen = !1)
        }, {
          "modal-header": a(() => [
            d(l.$slots, "modal-header")
          ]),
          "modal-body": a(({ preference: p, index: m }) => [
            d(l.$slots, "modal-body", {
              preference: p,
              index: m
            })
          ]),
          "modal-footer": a(() => [
            d(l.$slots, "modal-footer")
          ]),
          _: 3
        }, 8, ["preferences", "show-accept-all-in-modal", "onCookieComplySave", "onCookieComplyAcceptAll"])) : y("", !0)
      ], 8, ["to"]))
    ])) : y("", !0)
  ], 64);
}
const Se = /* @__PURE__ */ M(he, [["render", we]]), Ie = {
  install: (l) => {
    !window || l.component("VueCookieComply", Se);
  }
};
export {
  Ie as default
};
